<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13ueqRZ/tc-custom/9781467456340.jpg?1708515865566" alt="This image is the cover for the book The Spirit and the Common Good"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Spirit and the Common Good
      </h1>
      <p class="bookDescription body article font2">
        <p>A fresh vision of the common good through pnumatological lenses</p><p>Daniela C. Augustine, a brilliant emerging scholar, offers a theological ethic for the common good. Augustine develops a public theology from a theological vision of creation as the household of the Triune God, bearing the image of God in a mutual sharing of divine love and justice, and as a sacrament of the divine presence. </p><p><i>The Spirit and the Common Good</i> expounds upon the application of this vision not only within the life of the church but also to the realm of politics, economics, and care for creation. The church serves a priestly and prophetic function for society, indeed for all of creation. This renewed vision becomes the foundation for constructing a theological ethic of planetary flourishing in and through commitment to a sustainable communal praxis of a shared future with the other and the different.</p><p>While emphatically theological in its approach, <i>The Spirit and the Common Good</i> engages readers with insights from political philosophy, sociology of religion, economics, and ecology, as well as forgiveness/reconciliation and peacebuilding studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniela C. Augustine, Miroslav Volf
      </h2>
      
      <p class="authorDescription body article"><B>Daniela C. Augustine</B>&#160;is reader in world Christianity at the University of Birmingham (UK) and associate professor of theological ethics, School of Religion, Lee University (USA). She serves as associate editor of the&#160;<I>Journal of Pentecostal Theology</I>&#160;and co-editor of T&amp;T Clark&#39;s Systematic Pentecostal and Charismatic Theology Series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?116e9fa2